import getFileExtension from "./file_extension";

import pngPlaceHolder from 'assets/images/file_icons/png.svg';
import wordPlaceHolder from 'assets/images/file_icons/word.svg';
import powerpointPlaceHolder from 'assets/images/file_icons/powerpoint.png';
import excelPlaceHolder from 'assets/images/file_icons/xls.svg';
import jpgPlaceHolder from 'assets/images/file_icons/jpg.svg';
import pdfPlaceHolder from 'assets/images/file_icons/pdf.svg';
import movPlaceHolder from 'assets/images/file_icons/mov.png';
import mp4PlaceHolder from 'assets/images/file_icons/mp4.svg';
import defaultPlaceHolder from 'assets/images/file_icons/default.png';

const fileTypeIcon = filename => {
  const fileTypes = {
    'png': pngPlaceHolder,
    'doc': wordPlaceHolder,
    'docx': wordPlaceHolder,
    'ppt': powerpointPlaceHolder,
    'pptx': powerpointPlaceHolder,
    'xls': excelPlaceHolder,
    'xlsx': excelPlaceHolder,
    'jpg': jpgPlaceHolder,
    'jpeg': jpgPlaceHolder,
    'pdf': pdfPlaceHolder,
    'mov': movPlaceHolder,
    'mp4': mp4PlaceHolder,
    'default': defaultPlaceHolder,
  };

  const ext = getFileExtension(filename);
  return fileTypes[ext] || fileTypes['default'];
};

export default fileTypeIcon;
